module.exports = __webpack_public_path__ + "portal-static/img/学生.d811642d.png";